import {
  Button,
  Col,
  Form,
  Row,
  Input,
  message,
  Select,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { stockIssueService, companyService } from "_services";
import { ExportTypes, ExportStatus } from "_helpers";

function Search(props) {
  const [form] = Form.useForm();
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    companyService.getSuggestion("?companyType=CUSTOMER").then((x) => {
      setCustomers(x.content);
    });
  }, []);

  const onFinish = (values) => {
    props.showSearchLoading(true);

    let searchParams = [];

    if (values.issueNumber) {
      searchParams.push(
        `issueNumber=${encodeURIComponent(values.issueNumber)}`
      );
    }
    if (values.customReferenceNumber) {
      searchParams.push(
        `customReferenceNumber=${encodeURIComponent(
          values.customReferenceNumber
        )}`
      );
    }

    if (values.dateRange) {
      searchParams.push(
        `fromDate=${encodeURIComponent(
          moment(values.dateRange[0]).startOf("day").format("YYYY-MM-DD")
        )}&toDate=${moment(values.dateRange[1])
          .startOf("day")
          .format("YYYY-MM-DD")}`
      );
    }
    if (values.orderStage) {
      searchParams.push(`orderStage=${encodeURIComponent(values.orderStage)}`);
    }
    if (values.stockIssueType) {
      searchParams.push(
        `stockIssueType=${encodeURIComponent(values.stockIssueType.toString())}`
      );
    }
    if (values.customer) {
      searchParams.push(`customerId=${encodeURIComponent(values.customer)}`);
    }

    const queryValue =
      searchParams.length > 0 ? `?${searchParams.join("&")}` : "";

    stockIssueService
      .search(queryValue)
      .then((data) => {
        props.onSearchResults(
          data.content,
          data.pagination.totalRecords,
          queryValue
        );
      })
      .catch((error) => {
        message.error(`${error}`);
        props.onSearchResults([], 0, "");
      });
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
    >
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="customReferenceNumber" label="Cus.Dec.No#">
            <Input
              placeholder="Custom's Declaration number / GRN Number"
              allowClear={true}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="stockIssueType" label="Export Type">
            <Select
              showSearch
              allowClear
              showArrow={false}
              optionFilterProp="children"
              placeholder="Export Type"
            >
              {ExportTypes.map((t, index) => (
                <Select.Option value={t.value} key={t.value}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="dateRange" label="Date Range">
            <DatePicker.RangePicker
              ranges={{
                Today: [moment(), moment()],
                "This Month": [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
              }}
            />
          </Form.Item>
        </Col>

        <Col span={6} style={{ textAlign: "right" }}>
          <div>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish({});
              }}
            >
              Clear
            </Button>
          </div>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="issueNumber" label="Issue Number">
            <Input placeholder="Issue Number" allowClear={true} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="orderStage" label="Export Status">
            <Select allowClear mode="multiple">
              {ExportStatus.map((t) => (
                <Select.Option value={t.value} key={t.value}>
                  {t.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item name="customer" label="Customer">
            <Select
              showSearch
              placeholder="Select a customer"
              optionFilterProp="children"
              allowClear={true}
            >
              {customers.map((c) => (
                <Select.Option value={c.id} key={c.id}>
                  {c.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}></Col>
      </Row>
    </Form>
  );
}

export default Search;
